import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BlockSpoilerComponent from '../BlockSpoilerComponent.js';
import 'wix-rich-content-common';
import '../SpoilerContainer.js';
import 'classnames';
import '../SpoilerDescriptionInput.js';
import '../EditableInputWrapper.js';
import '../RevealButton.js';
import '../../icons/SpoilerContainerIcon.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../../spoiler-28b51954.js';
import 'lodash';
import '../../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var SpoilerEditorWrapper = (config) => (WrappedComponent) => {
  var _a;
  return _a = class extends Component {
    constructor(props) {
      var _a2;
      super(props);
      __publicField(this, "handleDescriptionChange", (description) => {
        this.updateComponentData({ description });
      });
      __publicField(this, "handleButtonContentChange", (buttonContent) => {
        this.updateComponentData({ buttonContent });
      });
      __publicField(this, "updateComponentData", (data) => {
        const { componentData } = this.props;
        const { spoiler } = componentData == null ? void 0 : componentData.config;
        const config2 = __spreadProps(__spreadValues({}, componentData == null ? void 0 : componentData.config), { spoiler: __spreadValues(__spreadValues({}, spoiler), data) });
        this.props.store.update(
          "componentData",
          __spreadProps(__spreadValues({}, componentData), { config: config2 }),
          this.props.block.getKey()
        );
      });
      const type = (_a2 = props.blockProps.type) == null ? void 0 : _a2.replace("wix-draft-plugin-", "");
      this.pluginType = type[0].toUpperCase() + type.slice(1);
    }
    render() {
      var _a2, _b, _c;
      const {
        componentData,
        theme,
        onClick,
        className,
        setInPluginEditingMode,
        blockProps,
        isMobile,
        t
      } = this.props;
      const hasSpoiler = ((_c = (_b = (_a2 = this.props.componentData) == null ? void 0 : _a2.config) == null ? void 0 : _b.spoiler) == null ? void 0 : _c.enabled) || false;
      return hasSpoiler ? /* @__PURE__ */ React.createElement(
        BlockSpoilerComponent,
        __spreadValues({
          disabledRevealSpoilerBtn: true,
          isEditableText: true,
          handleButtonContentChange: this.handleButtonContentChange,
          handleDescriptionChange: this.handleDescriptionChange,
          pluginType: this.pluginType,
          componentData,
          theme,
          onClick,
          className,
          setFocusToBlock: blockProps == null ? void 0 : blockProps.setFocusToBlock,
          setInPluginEditingMode,
          isMobile,
          t
        }, config),
        /* @__PURE__ */ React.createElement(WrappedComponent, __spreadValues({}, this.props))
      ) : /* @__PURE__ */ React.createElement(WrappedComponent, __spreadValues({}, this.props));
    }
  }, __publicField(_a, "alignmentClassName", WrappedComponent == null ? void 0 : WrappedComponent.alignmentClassName), __publicField(_a, "sizeClassName", WrappedComponent == null ? void 0 : WrappedComponent.sizeClassName), __publicField(_a, "textWrapClassName", WrappedComponent == null ? void 0 : WrappedComponent.textWrapClassName), __publicField(_a, "customClassName", WrappedComponent == null ? void 0 : WrappedComponent.customClassName), __publicField(_a, "propTypes", {
    blockProps: PropTypes.object,
    componentData: PropTypes.object,
    theme: PropTypes.object,
    pluginType: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    setFocusToBlock: PropTypes.func,
    setInPluginEditingMode: PropTypes.func,
    store: PropTypes.object,
    block: PropTypes.object,
    t: PropTypes.func,
    isMobile: PropTypes.bool
  }), _a;
};

export { SpoilerEditorWrapper as default };
//# sourceMappingURL=SpoilerEditorWrapper.js.map
